// extracted by mini-css-extract-plugin
export var footnotes = "footnotes-module--footnotes--18-HX";